<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col-12 col-md-12 col-lg-8">
          <h1 class="text-white pt-3 px-3">รายงานยอดการส่งด้วยระบบการส่งพัสดุ {{ $THEME.webTitle==='POP SHIPPOP'?'SHIPPOP':$THEME.webTitle}}</h1>
          <p
            class="text-white pb-0 px-3"
          >แสดงข้อมูลการใช้งาน รหัส {{$THEME.webTitle==='POP SHIPPOP'?'SHIPPOP':$THEME.webTitle}} และรายละเอียดการส่งด้วยระบบ  {{$THEME.webTitle==='POP SHIPPOP'?'SHIPPOP':$THEME.webTitle}} ทั้งหมด</p>
        </div>
        <div class="col-12 col-md-12 col-lg-4 align-self-center text-right">
          <h1 class="display-3 text-white">
            <small>จำนวนพัสดุ :</small>
             {{pagination.total_order| numFormat('0,0')}}
            <small>ชิ้น</small>
          </h1>
          <h1 class="display-3 text-white">
            <small>ยอดรวมค่าบริการพื้นที่พิเศษ :</small>
             {{totalRemoteArea | numFormat('0,0')}}
            <small>บาท</small>
          </h1>
        </div>
      </div>
    </base-header>
    <MadalRemark :getShow="modal_remark.show" :submit="modalBtnSubmit" :getDetails="modal_remark.data">
      <template slot="custom-header-order_log_update">
        <h3>{{'พัสดุมีการอัพเดท มีรายละเอียดดังนี้'}}</h3>
      </template>
      <template slot="custom-weight">{{ $THEME.unitKG ? 'น้ำหนัก (กิโลกรัม)' : 'น้ำหนัก (กรัม)'}}</template>
      <template slot="custom-dimension">{{'ขนาดพัสดุ (กxยxส ซม.)'}}</template>
      <template slot="custom-length">{{'x'}}</template>
      <template slot="custom-height">{{'x'}}</template>
      <template slot="custom-cost">{{'ต้นทุน'}}</template>
      <template slot="custom-rate">{{'ต้นทุนร้านค้า'}}</template>
      <template slot="custom-price">{{'ราคาขาย'}}</template>
      <template slot="custom-created_at">{{'วันที่สร้างรายการ'}}</template>
    </MadalRemark>
    <div class="container-fluid mt--7 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-10 mb-2 d-flex align-items-center">
                      <b-form-radio-group
                        id="radio-group-1"
                        v-model="filterSelectDate"
                        :options="filterDate"
                        name="radio-options"
                      ></b-form-radio-group>             
                      <!-- <label class="mb-0 p-custom text-muted">(วันเริ่มต้น - วันสุดท้าย)</label> -->
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col">
                      <input 
                        type="datetime-local"
                        @input="logEvent('startSelection', $event.target.value)"
                        v-model="filters.startDate" 
                        class="form-control form-control-lg" 
                        :min="minDate" :max="maxDate"/>
                    </div>
                    <div class="col">
                      <input 
                        type="datetime-local" 
                        @input="logEvent('finishSelection', $event.target.value)"
                        v-model="filters.endDate" 
                        class="form-control form-control-lg" 
                        :min="minDate" :max="maxDate" />
                    </div>
                    <div class="col-lg" v-if="visibleSerachBox.listShop">
                      <v-select
                        :options="listShop"
                        class="custom-dropdown"
                        placeholder="ค้นหาร้านค้า"
                        :class="{ 'is-invalid bd-danger': validate && $v.inputSelectShop.$invalid }"
                        v-model="inputSelectShop"
                        label="name"
                        :reduce="inputSelectShop => inputSelectShop.id"
                        taggable
                      >
                        <template slot="option" slot-scope="option">
                                {{ (option.shop_code || '') + ' ('+option.name+')' }}
                        </template>
                      </v-select>
                      <div
                        v-if="validate && $v.inputSelectShop.$invalid"
                        class="invalid-feedback d-block">กรุณาเลือกร้านค้า
                      </div>
                    </div>
                    <div class="col-lg-3">
                       <v-select
                        :options="listCourier"
                        class="custom-dropdown"
                        label="name"
                        placeholder="ค้นหาขนส่ง"
                        v-model="inputSelectCourier"
                        :reduce="listCourier => listCourier.key"
                        taggable
                      ></v-select>
                    </div>
                    <div class="col-lg-1">
                      <!-- exportOrderShippop , getReportShippop -->
                      <button class="btn btn-info btn-sm-res btn-block" @click="searchType = 'date' , getReportShippop()">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                  <hr class="d-md-none d-lg-none" />
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-lg-4 mb-3 mb-md-0">
                      <b-form-group description="( หมายเลขติดตามพัสดุ )" label="ค้นหาข้อมูล" class="mb-0" >
                        <div class="row">
                          <div class="col-8">
                            <b-form-input type="text" 
                              v-model="search.tracking_code"
                              placeholder="ค้นหาข้อมูลหมายเลขติดตามพัสดุ">
                            </b-form-input>
                          </div>
                          <div class="col">
                            <button class="btn btn-info btn-sm-res" @click="searchType = 'tracking' , getReportShippop()">
                              <i class="fa fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-lg-3 mb-3">
                      <b-form-group label="ค้นหาข้อมูล (ไม่ต้องกดค้นหา)" class="mb-0 pb-2">
                        <input type="text" class="form-control" v-model="filter"/>
                      </b-form-group>
                    </div>
                    <div class="col d-flex justify-content-end">
                      <b-form-group label="Export File" class="mb-0 pb-2">
                        <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                            <b-button 
                                variant="success"
                                @click="exportExcel()"
                            >
                                <div class="circle-loading" v-if="filters.isLoadingBtn"></div>
                                <template v-else> excel </template>
                            </b-button>
                            <b-button 
                                variant="info btn-sm-res" 
                                @click="$htmlToPaper('tablePrint')"
                            >print
                            </b-button>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <hr class="d-block d-md-none d-lg-none mb-0" />
              </div>
           
            </div>
            <div id="tablePrint">
              <b-table 
                show-empty 
                responsive
                empty-text="ไม่มีรายละเอียดข้อมูลยอดขาย"
                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                :items="reportShippop" 
                :fields="fields"
                :filter="filter"
                :busy="busy"
                foot-clone
                sticky-header
                class="scroll-bar-pop text-center table-sticky"
              >
                <div slot="HEAD_rate" slot-scope="row">
                        {{row.label}} 
                        <i 
                            class="fas fa-info-circle fa-xs text-primary cursor-pointer" 
                            v-b-tooltip
                            title='ราคาต้นทุนที่คำนวณจาก ขนาดพัสดุและน้ำหนัก "ที่ร้านค้าระบุตอนสร้างรายการ"'>
                        </i>
                </div>
                <div slot="HEAD_r_rate" slot-scope="row">
                        {{row.label}} 
                        <i 
                            class="fas fa-info-circle fa-xs text-primary cursor-pointer" 
                            v-b-tooltip
                            title='ราคาต้นทุนที่คำนวณจาก ขนาดพัสดุและน้ำหนัก "ที่ได้รับจากขนส่ง"'>
                        </i>
                </div>
                <div slot="HEAD_price" slot-scope="row">
                        {{row.label}} 
                        <i 
                            class="fas fa-info-circle fa-xs text-primary cursor-pointer" 
                            v-b-tooltip
                            title='ราคาขายที่คำนวณจาก ขนาดพัสดุและน้ำหนัก "ที่ร้านค้าระบุตอนสร้างรายการ"'>
                        </i>
                </div>
              <div slot="table-busy" class="text-center">
                <BlockUI>
                    <div class="loader"></div>
                </BlockUI>
              </div>
              <template slot="status" slot-scope="row">
                <b-badge :variant="statusInfo(row.item, {courier_code: 'courier_key'}).color +' report'"
                  v-b-tooltip :title="statusInfo(row.item, {courier_code: 'courier_key'}).tooltip" >
                  {{statusInfo(row.item, {courier_code: 'courier_key'}).status}}
                </b-badge>
              </template>
              <template slot="rate" slot-scope="row">
                <span 
                    v-b-tooltip
                    :title="courierRules.getZoneName({
                      key: row.item.courier_key,
                      shipment_created_at: row.item.created_at
                      } , row.item.rate_type)"
                >
                    {{ row.item.rate | numFormat('0,0.00') }}
                </span>
              </template>
              <template slot="r_rate" slot-scope="row">
                <template v-if="row.item.r_rate == null">
                  -
                </template>
                <template v-else>
                    <span 
                        v-b-tooltip 
                        :title="courierRules.getZoneName({key: row.item.courier_key} , row.item.rate_type)"
                    >
                        {{ row.item.r_rate | numFormat('0,0.00') }}
                    </span>
                </template>
              </template>
               <template slot="rcost" slot-scope="row">
                <template v-if="row.item.rcost == null">
                  -
                </template>
                <template v-else>{{ row.item.rcost | numFormat('0,0.00') }}</template>
              </template>
              <template slot="rweight" slot-scope="row">
                <template v-if="row.item.rweight == null">
                  -
                </template>
                <template v-else>{{ ( $THEME.unitKG ) ? (row.item.rweight / 1000) : row.item.rweight }}</template>
              </template>
              <template slot="date_time_shipping" slot-scope="row">
                <template v-if="row.item.date_time_shipping == null">
                  -
                </template>
                <template v-else>{{row.item.date_time_shipping}}</template>
              </template>
              <template slot="date_time_weight" slot-scope="row">
                <template v-if="row.item.date_time_weight == null">
                  -
                </template>
                <template v-else>{{row.item.date_time_weight}}</template>
              </template>
              <template slot="dimension" slot-scope="row">
                {{ ( Number(row.item.dimension.width) + Number(row.item.dimension.length) + Number(row.item.dimension.height) ) > 3 ? row.item.dimension.width+'x'+row.item.dimension.length+'x'+row.item.dimension.height:'-'}}
              </template>
              <template slot="rdimension" slot-scope="row">
                <template
                  v-if="( Number(row.item.dimension.width) + Number(row.item.dimension.length) + Number(row.item.dimension.height) ) > 3 && ( Number(row.item.rdimension.width) + Number(row.item.rdimension.length) + Number(row.item.rdimension.height) ) < 3">
                  -
                </template>
                <template
                  v-else-if="( Number(row.item.dimension.width) + Number(row.item.dimension.length) + Number(row.item.dimension.height) ) <= 3">
                  -
                </template>
                <template v-else>
                  {{row.item.rdimension.width+'x'+row.item.rdimension.length+'x'+row.item.rdimension.height}}
                </template>
              </template>
              <template slot="remote_area" slot-scope="row">
                <template v-if="row.item.remote_area > 0">
                  {{ row.item.remote_area | numFormat('0,0.00') }}
                </template>
                <template v-else>-</template>
              </template>
              <template slot="r_remote_area" slot-scope="row">
                <template v-if="row.item.r_remote_area > 0">
                  {{ row.item.r_remote_area | numFormat('0,0.00') }}
                </template>
                <template v-else>-</template>
              </template>
              <template slot="travel_surcharge" slot-scope="row">
                <template v-if="row.item.travel_surcharge > 0">
                  {{ row.item.travel_surcharge | numFormat('0,0.00') }}
                </template>
                <template v-else>-</template>
              </template>
              <template slot="r_travel_surcharge" slot-scope="row">
                <template v-if="row.item.r_travel_surcharge > 0">
                  {{ row.item.r_travel_surcharge | numFormat('0,0.00') }}
                </template>
                <template v-else>-</template>
              </template>
              <template slot="island_surcharge" slot-scope="row">
                <template v-if="row.item.island_surcharge > 0">
                  {{ row.item.island_surcharge | numFormat('0,0.00') }}
                </template>
                <template v-else>-</template>
              </template>
              <template slot="r_island_surcharge" slot-scope="row">
                <template v-if="row.item.r_island_surcharge > 0">
                  {{ row.item.r_island_surcharge | numFormat('0,0.00') }}
                </template>
                <template v-else>-</template>
              </template>
              <template slot="insurance_cost" slot-scope="row">
                <template v-if="row.item.insurance_cost">
                  {{ row.item.insurance_cost| numFormat('0,0.00') }}
                </template>
                <template v-else>-</template>
              </template>
              <template slot="insurance_rate" slot-scope="row">
                <template v-if="row.item.insurance_rate">
                  {{ row.item.insurance_rate | numFormat('0,0.00') }}
                </template>
                <template v-else>-</template>
              </template>
              <template slot="insurance_price" slot-scope="row">
                <template v-if="row.item.insurance_price">
                  {{ row.item.insurance_price | numFormat('0,0.00') }}
                </template>
                <template v-else>-</template>
              </template>
              <template slot="transaction_id" slot-scope="row">
                <template v-if="row.item.transaction_id">
                  Wallet <i class="fas fa-wallet" v-b-tooltip :title="'Transaction ID:' +row.item.transaction_id"></i>
                </template>
                <template v-else>Credit Term</template>
              </template>
              <template slot="remark" slot-scope="row">
                <template v-if="row.item.remark.status">
                  <b-button variant="link" @click="remarkDetails( row.item.remark )">ดูรายละเอียด</b-button>
                </template>
                <template v-else>
                  -
                </template>
              </template>
              <template slot="shop_code" slot-scope="row">
                <template v-if="row.item.shop_code">
                  {{ row.item.shop_code }}
                </template>
                <template v-else>-</template>
              </template>

              <template slot="weight" slot-scope="row">
                {{ (row.item.weight) ? ( ( $THEME.unitKG ) ? (row.item.weight / 1000) : row.item.weight ) : '-'}}
              </template>

              <template slot="coupon" slot-scope="row" v-if="allowCouponColumn">
                <template v-if="row.item.coupon">
                  {{ row.item.coupon.total_value | numFormat('0,0.00') }}
                </template>
                <template v-else>
                  -
                </template>
              </template>

                <!-- footer table -->
                <template slot="FOOT_status"> รวม</template>
                <template slot="FOOT_created_at"> &nbsp;</template>
                <template slot="FOOT_date_time_shipping"> &nbsp;</template>
                <template slot="FOOT_date_time_weight"> &nbsp;</template>
                <template slot="FOOT_shop_name"> &nbsp;</template>
                <template slot="FOOT_courier_type"> &nbsp;</template>
                <template slot="FOOT_courier"> &nbsp;</template>
                <template slot="FOOT_tracking_code"> &nbsp;</template>
                <template slot="FOOT_dimension"> &nbsp;</template>
                <template slot="FOOT_rdimension"> &nbsp;</template>
                <template slot="FOOT_remark"> &nbsp;</template>
                <template slot="FOOT_cost">{{footerTotal.cost| numFormat('0,0.00')}}</template>
                <template slot="FOOT_rcost">{{footerTotal.rcost| numFormat('0,0.00')}}</template>
                <template slot="FOOT_rate">{{footerTotal.rate| numFormat('0,0.00') }}</template>
                <template slot="FOOT_r_rate">{{footerTotal.r_rate| numFormat('0,0.00') }}</template>
                <template slot="FOOT_price">{{footerTotal.price| numFormat('0,0.00') }}</template>
                <template slot="FOOT_coupon" v-if="allowCouponColumn">{{footerTotal.coupon| numFormat('0,0.00') }}</template>
                <template slot="FOOT_cod_amount">{{footerTotal.cod_amount| numFormat('0,0.00') }}</template>
                <template slot="FOOT_weight">&nbsp;</template>
                <template slot="FOOT_rweight">&nbsp;</template>
                <template slot="FOOT_remote_area">{{footerTotal.remote_area| numFormat('0,0.00') }}</template>
                <template slot="FOOT_r_remote_area">{{footerTotal.r_remote_area| numFormat('0,0.00') }}</template>
                <template slot="FOOT_travel_surcharge">{{footerTotal.travel_surcharge| numFormat('0,0.00') }}</template>
                <template slot="FOOT_r_travel_surcharge">{{footerTotal.r_travel_surcharge| numFormat('0,0.00') }}</template>
                <template slot="FOOT_island_surcharge">{{footerTotal.island_surcharge| numFormat('0,0.00') }}</template>
                <template slot="FOOT_r_island_surcharge">{{footerTotal.r_island_surcharge| numFormat('0,0.00') }}</template>
                <template slot="FOOT_fuel_surcharge">{{footerTotal.fuel_surcharge| numFormat('0,0.00') }}</template>
                <template slot="FOOT_r_fuel_surcharge">{{footerTotal.r_fuel_surcharge| numFormat('0,0.00') }}</template>
                <template slot="FOOT_extra_handling_charge">{{footerTotal.extra_handling_charge| numFormat('0,0.00') }}</template>
                <template slot="FOOT_r_extra_handling_charge">{{footerTotal.r_extra_handling_charge| numFormat('0,0.00') }}</template>
                <template slot="FOOT_insurance_price">
                  {{footerTotal.insurance_price| numFormat('0,0.00') }}
                </template>
                <template slot="FOOT_insurance_rate">
                  {{footerTotal.insurance_rate| numFormat('0,0.00') }}
                </template>
                <template slot="FOOT_insurance_cost">
                  {{footerTotal.insurance_cost| numFormat('0,0.00') }}
                </template>
                <template slot="FOOT_transaction_id">&nbsp;</template>
                <template slot="FOOT_shop_code">&nbsp;</template>
              </b-table>
              <div class="mt-3">
                <b-pagination
                    :total-rows="pagination.total_order"
                    :current-page="pagination.current_page"
                    :per-page="pagination.per_page"
                    :value="pagination.current_page" 
                    @input="changePage"
                    align="right"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalNotification :notiShop="noti" />
  </div>
</template>
<script>
import validatePop from "../../plugins/validatePop.js"
import { required } from "vuelidate/lib/validators"
import moment from "moment"
import MadalRemark from '@/components/Modals/Modal-remark'
import ModalNotification from '@/components/custom/ModalNotification'
import { statusCourier, statusInfo } from "@/plugins/statusCourier.js"
import { checkStatusShop } from "@/axios/noti.js";
import { dateLimitRanges } from "@/plugins/datePicker.js"
import courierRules from '@/constants/CourierRules';
import { getReportShippops } from "@/axios/report.js";
import { showErrorModal } from "@/components/modalNotification.js";

const DATE_NOW = moment().format("YYYY-MM-DD")
const API_URL = process.env.VUE_APP_API
export default {
  name: "reportshippop",
  data() {
    return {
      statusCourier:statusCourier,
      statusInfo: statusInfo,
      courierRules:courierRules,
      userLogin:'',
      reportShippop: [],
      totalRemoteArea: 0,
      pagination:{
        total_order: 0,
        current_page: 1,
        per_page: 0
      },
      listShop:[],
      listCourier:[ {key:null , name:"ดูทั้งหมด"} ],
      inputSelectCourier: null,
      inputSelectShop: null,
      selectCourierFilter:undefined,
      selectShopFilter:undefined,
      filterSelectDate: 'created_at',
      validate: false,
      minDate: null,
      maxDate: moment().format("YYYY-MM-DD[T]HH:mm"),
      filterDate: [
          { text: 'ค้นหาวันที่สร้าง', value: 'created_at' },
          { text: 'ค้นหาวันที่ได้รับน้ำหนักจากขนส่ง', value: 'date_time_weight' },
      ],
      busy: false,
      filter: null,
      filters: {
        startDate: "",
        endDate: "",
        date_excel: "",
        isLoadingBtn: false
      },
      search:{
        tracking_code:"",
      },
      searchType:"date",
      modal_remark: {
        show : false ,
        data : {}
      },
      noti:{
        show:false,
        type:"",
        created_by:"",
        router:false
      }
    }
  },
  components: {
    MadalRemark,
    ModalNotification
  },
  filters: {
    // dateFormat(date) {
    //   return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    // },
  },
  beforeMount(){
    this.userLogin = JSON.parse(localStorage.getItem("user"))
  },
  mounted() {
    if( this.$USER_LOGIN.get().isSuperadmin ){
        checkStatusShop().then(res => {
            if( res.status_shop == 'LOCK' ){
                this.noti.created_by = res.created_by
                this.noti.type = res.status_shop
                this.noti.show = true
            }
        })
    }
    this.getDateNow()
    this.defaultLoad()
  },
  validations(){
    let res = { inputSelectShop: {} }
    const role = this.$USER_LOGIN.get()

    if( role.isSuperadmin && this.searchType == 'date'|| role.isShippop && this.searchType == 'date' ){
      res = {
        inputSelectShop: { required }
      }
    }

    return res
  },
  methods: {
    exportExcel(){
        let check = this.validateBeforeSubmit()
        if( !check ){
            return false
            
        }

        if (this.$THEME.exportLoading && !['member', 'admin', 'shippop'].includes(this.isWho())) {
            return false;
        }
        
        this.filters.isLoadingBtn = true

        let bodyObject = {
            searchType: this.searchType,
            startDate: this.filters.startDate,
            endDate: this.filters.endDate,
            courierKey: this.inputSelectCourier,
            trackingCode: this.search.tracking_code,
            dateType: this.filterSelectDate,
            shop: this.inputSelectShop,
            current_page: this.pagination.current_page,
            is_excel: true
        }

        getReportShippops( bodyObject ).then( res => {
            let url = res.url;
            if(url){
                const link = document.createElement('a')
                link.href = url
                link.download = `report-shippop-${DATE_NOW}.xlsx`
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }else{
                showErrorModal( 'ไม่มีข้อมูล' )
            }
            this.filters.isLoadingBtn = false
        }).catch( error => {
            this.filters.isLoadingBtn = false
            showErrorModal(error)
        });
    },
    logEvent( event , date ){
        const { minDate , maxDate } = dateLimitRanges(event, date, "YYYY-MM-DD[T]HH:mm");
        this.minDate = minDate
        this.maxDate = maxDate
    },
    async defaultLoad(){
      this.busy = true
      const user = this.$USER_LOGIN.get()
      await this.getListCourier()

      if( user.isSuperadmin || user.isShippop ){

        await this.getListShop()
        
      }
      this.busy = false

    },
    changePage(i){
      if (this.pagination.current_page == i) return
      this.pagination.current_page = i
      this.getReportShippop()
    },
    isWho(){
      return this.userLogin.role
    },
    async getListShop(){
      return this.$http.get( API_URL + "/shop/list" , {
        headers: {
          Token: localStorage.getItem("access_token")
        }

      }).then( res => {
        this.listShop = res.data.data
      })
    },
    async getListCourier(){
      return this.$http.get( API_URL + "/courier/list" , {
        headers: {
          Token: localStorage.getItem("access_token")
        }

      }).then( res => {
        this.listCourier = [ ...this.listCourier , ...res.data.data ]
      })
    },
    validateBeforeSubmit(){
      this.validate = true
      this.$v.$touch()

      if( this.$v.inputSelectShop.$invalid ){
        return false
      }else{
        return true
      }
    },
    getReportShippop(){
      let check = this.validateBeforeSubmit()
      if( !check ){
        return false
      }

      this.busy = true
      this.$http
        .post(
          API_URL + "/admin/shippops",
          {
            ...( ( this.searchType == 'date' ) ? {  
                start: this.filters.startDate , 
                end: this.filters.endDate, 
                courierKey: this.inputSelectCourier, 
            } : { 
                start: false , 
                end: false , 
                trackingCode: this.search.tracking_code 
            } ),
            dateType: this.filterSelectDate,
            shop: this.inputSelectShop,
            page: this.pagination.current_page
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {

          let data = res.data.data
          this.validate = true
          let checkError = validatePop( res )
            if( !checkError.status ){
              if( checkError.notices == "token is expired"){
                this.$router.push("/logout")
              }
              this.busy = false
              showErrorModal( checkError.msg )
              return false
            }
          this.busy = false
          this.reportShippop = data.orders
          this.totalRemoteArea = data.total_remote_area
          this.pagination.total_order = data.total_item
          this.pagination.per_page = data.per_page
          this.pagination.current_page = data.page
        })
    },
    getDateNow(){
      let now = moment()
      this.filters.endDate = now.format("YYYY-MM-DDTkk:mm")
      this.filters.startDate = now.subtract(1, "days").format("YYYY-MM-DDTkk:mm")
      this.filters.date_excel = now.format("YYYY-MM-DD")
    },
    remarkDetails( data ){

      let parcel_updated = data.data.order_log_update
      let send =  { 'status' : data.status ,
                    'data' : {
                      'order_log_update' : { 'dimension' : {'width':'' , 'length': '' , 'height': ''} } 
                    }
                  }
      for(let key in parcel_updated ){
        if( ['width' , 'length' , 'height'].includes(key) ){
          send.data.order_log_update.dimension[key] = parcel_updated[key]
        }else{
          send.data.order_log_update[key] = parcel_updated[key]
        }
      }
      this.modal_remark.data = send
      this.modal_remark.show = true

    },
    modalBtnSubmit(){
      this.modal_remark.show = false
    },
    setFormatRemark( data ){
      const user = this.$USER_LOGIN.get()
      if( !data.status ) return `-`

        let res = `พัสดุมีการอัพเดท มีรายละเอียดดังนี้\r\nน้ำหนัก (กรัม): ${data.data.order_log_update.weight} \r\nขนาดพัสดุ   (กxยxส ซม.) :${data.data.order_log_update.width}x${data.data.order_log_update.length}x${data.data.order_log_update.height} \r\nต้นทุน : ${data.data.order_log_update.cost} \r\nต้นทุนร้านค้า : ${data.data.order_log_update.rate} \r\nราคาขาย : ${data.data.order_log_update.price} \r\nวันที่สร้างรายการ : ${data.data.order_log_update.created_at}`


      if( user.isAdmin ) return res = `พัสดุมีการอัพเดท มีรายละเอียดดังนี้\r\nน้ำหนัก : ${data.data.order_log_update.weight}  \r\nขนาดพัสดุ (กxยxส ซม.) :${data.data.order_log_update.width}x${data.data.order_log_update.length}x${data.data.order_log_update.height} \r\nต้นทุน : ${data.data.order_log_update.rate} \r\nราคาขาย : ${data.data.order_log_update.price} \r\nวันที่สร้างรายการ : ${data.data.order_log_update.created_at}`
      
      if( !user.isAdmin && !user.isSuperadmin ) return res = `พัสดุมีการอัพเดท มีรายละเอียดดังนี้\r\nน้ำหนัก : ${data.data.order_log_update.weight} \r\nขนาดพัสดุ (กxยxส ซม.) :${data.data.order_log_update.width}x${data.data.order_log_update.length}x${data.data.order_log_update.height} \r\nราคาขาย : ${data.data.order_log_update.price} \r\nวันที่สร้างรายการ : ${data.data.order_log_update.created_at}`

      return res
                  
    },
    formatExcel(item){
      let data = [ ...item ];
      let total = { 
        cost: 0, 
        rcost: 0, 
        rate: 0, 
        r_rate: 0 , 
        price: 0,
        cod_amount: 0, 
        remote_area: 0, 
        insurance_price: 0, 
        insurance_cost: 0, 
        insurance_rate: 0
      }
      if(item.length > 0){
        data.forEach(item => {
          if( item.status != 'PENDING_CANCEL' && item.status != 'CANCEL' ){
            total.cost += +item.cost
            total.rcost += +item.rcost
            total.rate += +item.rate
            total.r_rate += +item.r_rate
            total.price += +item.price
            total.cod_amount += +item.cod_amount
            total.remote_area += +item.remote_area
            total.insurance_cost += +item.insurance_cost
            total.insurance_rate += +item.insurance_rate
            total.insurance_price += +item.insurance_price
          }
        })
        let format = {
          status:'',
          courier:'',
          tracking_code:'',
          weight:'',
          rweight:'',
          dimension:'',
          rdimension:'',
          cost: total.cost,
          rcost:  total.rcost,
          rate: total.rate,
          r_rate: total.r_rate,
          price: total.price,
          remote_area: total.remote_area,
          insurance_cost: total.insurance_cost,
          insurance_rate: total.insurance_rate,
          insurance_price: total.insurance_price,
          cod_amount: total.cod_amount,
          created_at:'',
          date_time_shipping:'',
          date_time_weight: '',
          transaction_id: '',
          remark:'',
          shop_code:'',
        }
        data.push(format);
      }
      return data;
    }
  },
  computed:{
    visibleSerachBox(){
      const user = this.$USER_LOGIN.get()
      let res = {
        listShop: true
      }

      if( user.isAdmin || user.isMember ){
          res.listShop = false
      }

      return res
    },
    fields(){      
      let fields = [
        { key: "status", label: "สถานะ", sortable: true },
        { key: "created_at", label: "วันที่สร้างรายการ", sortable: true },
        { key: "date_time_shipping", label: "วันที่ขนส่งเข้ารับพัสดุ", sortable: true },
        { key: "date_time_weight", label: "วันที่ได้รับน้ำหนักจากขนส่ง", sortable: true },
        // { key: "shop_name", label: "ชื่อสาขา", sortable: true },
        { key: "courier", label: "ชื่อขนส่ง", sortable: true },
        { key: "courier_type", label: "ประเภทขนส่ง", sortable: true },
        { key: "tracking_code", label: "หมายเลขติดตามพัสดุ", sortable: true },
        { key: "weight", label:  ( this.$THEME.unitKG ) ? 'น้ำหนัก (กิโลกรัม)':'น้ำหนัก (กรัม)' , sortable: true },
        { key: "rweight", label: ( this.$THEME.unitKG ) ? 'น้ำหนักจริง (กิโลกรัม)':'น้ำหนักจริง (กรัม)' , sortable: true },
        { key: "dimension", label: "ขนาดพัสดุ (ซม.)", sortable: true },
        { key: "rdimension", label: "ขนาดพัสดุจริง (ซม.)", sortable: true },
        { key: "cost", label: "ต้นทุน", sortable: true },
        { key: "rcost", label: "ต้นทุนจริง", sortable: true },
        { 
          key: "rate", label: ['superadmin', 'shippop'].includes( this.isWho() )
          ? 'ต้นทุนร้านค้า'
          : 'ต้นทุน',
          sortable: true 
        },
        { 
          key: "r_rate", label: ['superadmin', 'shippop'].includes( this.isWho() )
          ? 'ต้นทุนร้านค้าจริง'
          :'ต้นทุนจริง', 
          sortable: true 
        },
        { 
          key: "price", label: 'ราคาขาย',
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value, '0,0.00')}`;
          }
        },
      ]

      if (this.allowCouponColumn) {
        fields.push({ key: 'coupon', label: 'คูปองส่วนลด' })
      }

      fields.push({ key: "cod_amount", label: "ยอด COD", sortable: true })
      fields.push({ key: "remote_area", label: "ค่าบริการพื้นที่พิเศษ", sortable: true })
      fields.push({ key: "r_remote_area", label: "ค่าบริการพื้นที่พิเศษจริง", sortable: true })
      fields.push({ key: "travel_surcharge", label: "ค่าบริการพื้นที่ท่องเที่ยว", sortable: true })
      fields.push({ key: "r_travel_surcharge", label: "ค่าบริการพื้นที่ท่องเที่ยวจริง", sortable: true })
      fields.push({ key: "island_surcharge", label: "ค่าพื้นที่หมู่เกาะ", sortable: true })
      fields.push({ key: "r_island_surcharge", label: "ค่าพื้นที่หมู่เกาะจริง", sortable: true })
      fields.push({ key: "fuel_surcharge", label: "Additional Fuel Charge", sortable: true })
      fields.push({ key: "r_fuel_surcharge", label: "Additional Fuel Charge จริง", sortable: true })
      fields.push({ key: "extra_handling_charge", label: "Extra Handling Charge", sortable: true })
      fields.push({ key: "r_extra_handling_charge", label: "Extra Handling Charge จริง", sortable: true })
      fields.push({ key: "insurance_cost", label: "ต้นทุนประกัน", sortable: true })
      fields.push({ 
          key: "insurance_rate", 
          label: ['superadmin', 'shippop'].includes( this.isWho() )
          ? "ต้นทุนประกัน(ร้านค้า)"
          : "ต้นทุนประกัน",
          sortable: true 
      })
      fields.push({ key: "insurance_price", label: "ราคาขายประกัน", sortable: true })
      fields.push({ key: "transaction_id", label: "ช่องทางการชำระเงิน", sortable: false })
      fields.push({ key: "remark", label: "หมายเหตุ", sortable: true })

      if(['shippop', 'superadmin'].includes(this.isWho())) {
        fields.push({ key: "shop_code", label: "รหัสร้านค้า", sortable: true })
      }
      if( this.isWho() == 'admin' ){
        return fields.filter(function (col) {
          return [ 'rcost','cost', 'insurance_cost' ].indexOf(col.key) < 0
        })
      }
      
      return fields
    },
    column() {
      let column = [
        {
          label: "สถานะ",
          field: "status"
        },
        {
          label: "ชื่อขนส่ง",
          field: "courier",
        },
        {
          label: "หมายเลขติดตามพัสดุ",
          field: "tracking_code",
        },
        {
          label: ( this.$THEME.unitKG ) ? 'น้ำหนัก (กิโลกรัม)':'น้ำหนัก (กรัม)',
          field: "weight",
          dataFormat: value => {
            return (value) ? ( ( this.$THEME.unitKG ) ? `${ (value / 1000) }` : `${value}` ) : '';
          }
        },
        {
          label: ( this.$THEME.unitKG ) ? 'น้ำหนักจริง (กิโลกรัม)':'น้ำหนักจริง (กรัม)',
          field: "rweight",
          dataFormat: value => {
            return (value) ? ( ( this.$THEME.unitKG ) ? `${ (value / 1000) }` : `${value}` ) : '';
          }
        },
        {
          label: "ขนาดพัสดุ กxยxส(ซม.)",
          field: "dimension",
          dataFormat: value => {
            return (value) ? `${value.width}x${value.length}x${value.height}` : '';
          }
        },
        {
          label: "ขนาดพัสดุจริง (ซม.)",
          field: "rdimension",
          dataFormat: value => {
            return (value) ? ( (+value.width) + (+value.length) + (+value.height) > 3 ) ? `${value.width}x${value.length}x${value.height}` : '-' : '' ;
          }
        },
        { 
          label: "ต้นทุน",
          field: "cost",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "ต้นทุนจริง",
          field: "rcost",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: this.isWho() == 'superadmin' ?'ต้นทุนร้านค้า':'ต้นทุน',
          field: "rate",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: this.isWho() == 'superadmin' ?'ต้นทุนร้านค้าจริง':'ต้นทุนจริง',
          field: "r_rate",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "ค่าบริการพื้นที่พิเศษ",
          field: "remote_area",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "ค่าบริการพื้นที่พิเศษจริง",
          field: "r_remote_area",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "Additional Fuel Charge",
          field: "fuel_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "Additional Fuel Charge จริง",
          field: "r_fuel_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "Extra Handling Charge",
          field: "extra_handling_charge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "Extra Handling Charge จริง",
          field: "r_extra_handling_charge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ต้นทุนประกัน",
          field: "insurance_cost",
          dataFormat: value => {
            let cost = value ? value : 0
            return `${this.$options.filters.numFormat(cost, '0,0.00')}`
          } 
        },
        {
          label: !['superadmin', 'shippop'].includes( this.isWho() ) 
          ? "ต้นทุนประกัน"
          : "ต้นทุนประกัน(ร้านค้า)",
          field: "insurance_rate",
          dataFormat: value => {
            let rate = value ? value : 0
            return `${this.$options.filters.numFormat(rate, '0,0.00')}`
          } 
        },
        {
          label: "ราคาขายประกัน",
          field: "insurance_price",
          dataFormat: value => {
            let price = value ? value : 0
            return `${this.$options.filters.numFormat(price, '0,0.00')}`
          } 
        },
        {
          label: "ยอด COD",
          field: "cod_amount",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "วันที่สร้างรายการ",
          field: "created_at",
        },
        {
          label: "วันที่ขนส่งเข้ารับพัสดุ",
          field: "date_time_shipping",
        },
        {
          label: "หมายเหตุ",
          field: "remark",
          dataFormat: value => {
            return (value) ? this.setFormatRemark( value ) : '';
          }
        }
      ];

      if (['shippop', 'superadmin'].includes(this.isWho())) {
        column.push({
          label: "รหัสร้านค้า",
          field: "shop_code",
        })
      }
      if( this.isWho() == 'admin' ){
        return column.filter(function (col) {
          return [ 'cost','rcost','shop_name', 'insurance_cost' ].indexOf(col.field) < 0
        })
      }

      return column

    },
    footerTotal() {
      let total = { 
        cost: 0, 
        rcost: 0, 
        price: 0, 
        rprice: 0, 
        rate: 0, 
        r_rate: 0 , 
        parcel: 0 , 
        cod_amount: 0, 
        remote_area: 0, 
        r_remote_area: 0, 
        travel_surcharge: 0, 
        r_travel_surcharge: 0, 
        island_surcharge: 0, 
        r_island_surcharge: 0, 
        fuel_surcharge: 0, 
        r_fuel_surcharge: 0, 
        extra_handling_charge: 0,
        r_extra_handling_charge: 0,
        insurance_cost: 0,
        insurance_rate: 0,
        insurance_price: 0, 
        coupon: 0
      }
      this.reportShippop.forEach(item => {
        if( item.status != 'PENDING_CANCEL' && item.status != 'CANCEL' ){
          total.parcel++
          total.cost += +item.cost
          total.rcost += +item.rcost
          total.price += +item.price
          total.rprice += +item.rprice
          total.rate += +item.rate
          total.r_rate += +item.r_rate
          total.cod_amount += +item.cod_amount
          total.remote_area += +item.remote_area
          total.r_remote_area += +item.r_remote_area
          total.travel_surcharge += +item.travel_surcharge
          total.r_travel_surcharge += +item.r_travel_surcharge
          total.island_surcharge += +item.island_surcharge
          total.r_island_surcharge += +item.r_island_surcharge
          total.fuel_surcharge += +item.fuel_surcharge
          total.r_fuel_surcharge += +item.r_fuel_surcharge
          total.extra_handling_charge += +item.extra_handling_charge
          total.r_extra_handling_charge += +item.r_extra_handling_charge
          total.insurance_cost += +item.insurance_cost
          total.insurance_rate += +item.insurance_rate
          total.insurance_price += +item.insurance_price
          total.coupon += (item.coupon ? +item.coupon.total_value : 0)
        }
      })
      return total;
    },
    allowCouponColumn() {
      return this.main_allow_coupon && this.main_use_walletV2
    }
  }
};
</script>

<style lang="scss" scoped>

  .report{
    color: #212529;
    font-size: 1.1rem;
   width: 100%;
  }
  .report-warning{
    background-color: #ffc10785;
  }
  
  .p-custom{
    padding-top: 2px;
  }
  



</style>
